import * as React from 'react';

import UnsubscribeModalGraphicSvg from './unsubscribe-modal-graphic.svg';

import styles from './onboarding-modal-graphic-styles.module.css';

export class UnsubscribeModalGraphic extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <UnsubscribeModalGraphicSvg />
            </div>
        );
    }
}
